<template lang="pug">
  .layout
    .layout__item
      button.layout__button(
        type="button",
        :class="{ 'is-active': displayType.type === 'tile'}",
        @click="changeLayoutType('tile')"
      )
        img.layout__icon(src="/static/img/app/btn-tile.svg")
      span.text-nowrap.layout__tooltip
        | タイル

    .layout__item
      button.layout__button(
        type="button",
        :class="{ 'is-active': displayType.type === 'sidebar'}",
        @click="changeLayoutType('sidebar')"
      )
        img.layout__icon(src="/static/img/app/btn-sidebar.svg")
      span.text-nowrap.layout__tooltip
        | サイドバー

    .layout__item
      button.layout__button(
        type="button",
        :class="{ 'is-active': displayType.type === 'popup'}",
        @click="changeLayoutType('popup')"
      )
        img.layout__icon(src="/static/img/app/btn-popup.svg")
      span.text-nowrap.layout__tooltip
        | ポップアップ

    .dropdown
      .layout__item(
        id="dropdownSpotlight",
        data-toggle="dropdown",
        aria-haspopup="true"
      )
        button.layout__button(
          type="button",
          :class="{ 'is-active': displayType.type === 'spotlight'}"
        )
          img.layout__icon(src="/static/img/app/btn-spotlight.svg")
        span.text-nowrap.layout__tooltip
          | スポットライト
      .dropdown-menu.dropdown-menu-right(aria-labelledby="dropdownSpotlight")
        .dropdown-item(
          v-for="(value, key) in users",
          @click="changeLayoutType('spotlight', key)"
        )
          | {{ value.name }}

    .custom-control.custom-switch
      input#displaySize.custom-control-input(
        v-model="displayType.cover",
        type="checkbox",
        @click="changeLayout"
      )
      label.custom-control-label.text-white(for="displaySize")
        | 拡大
</template>

<script>
import 'bootstrap'

export default {
  name: 'Layout',
  data () {
    return {
      displayType: {
        cover: true,
        type: 'tile',
        mainStreamPeerId: ''
      }
    }
  },
  computed: {
    layout () {
      return this.$store.state.layout
    },
    peerId () {
      return this.$store.state.peerId
    },
    users () {
      return this.$store.state.users
    }
  },
  watch: {
    layout () {
      this.displayType = this.layout
    }
  },
  methods: {
    changeLayoutType (type, peerId) {
      // サイドバーで、メイン表示のユーザーが無い場合、他ユーザーをメインに設定
      // 他ユーザーがいない場合は自分をメインに設定
      if (['sidebar', 'popup'].includes(type) && !this.displayType.mainStreamPeerId) {
        this.displayType.mainStreamPeerId = Object.keys(this.users).find((peerId) => {
          return peerId !== this.peerId
        }) || this.peerId
      }

      // スポットライトの場合は、押下したユーザーをメインに切り替え
      if (type === 'spotlight') {
        this.displayType.mainStreamPeerId = peerId
      }

      this.displayType.type = type
      this.changeLayout()
    },
    changeLayout () {
      this.$store.dispatch('updateLayout', { layout: this.displayType })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  &-menu {
    top: calc(100% + 5px);
    max-width: 200px;
  }

  &-item {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
